module.exports = __webpack_public_path__ + "static/media/undraw_developer.c35acf18.png";